import React, { useState } from "react";
import Title from "./../ReusableComponents/title";
import { MenuItem, Select, Grid, createSvgIcon } from "@mui/material";
import "../../assets/css/Trademate.scss";
import Rating from "@mui/material/Rating";
import CKEditor from "./CKEditor";

const Empty = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 6.92312H11.5881L9.375 0L7.16187 6.92312H0L5.79406 11.2022L3.58094 18.125L9.375 13.8466L15.1691 18.125L12.9559 11.2025L18.75 6.92312Z"
      fill="#8B8E93"
    />
  </svg>,
  "Home"
);

const Fill = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 6.92312H11.5881L9.375 0L7.16187 6.92312H0L5.79406 11.2022L3.58094 18.125L9.375 13.8466L15.1691 18.125L12.9559 11.2025L18.75 6.92312Z"
      fill="#04D9FF"
    />
  </svg>,
  "Home"
);

const parseDate = (date) => {
  // Return "2022-07-25";
  const dateIns = new Date(date);
  let month = dateIns.getMonth() + 1;
  if (month < 10) {
    month = `0${month.toString()}`;
  }
  return `${dateIns.getFullYear()}-${month}-${dateIns.getDate()}`;
};

const CreateTrader = (props) => {
  const { prefetchData } = props;
  const [Data, setData] = useState({
    date: (prefetchData && parseDate(prefetchData.date)) || null,
    symbol: (prefetchData && prefetchData.symbol) || "",
    trade_type: (prefetchData && prefetchData.action) || "Buy",
    entry: (prefetchData && prefetchData.entry) || "In",
    counter_trend: null,
    trigger: "",
    supporting_evidence: "",
    opposing_evidence: "",
    heads_up: "",
    notes: "",
    alerts_placed: null,
    order_price: (prefetchData && prefetchData.price) || "",
    profit: (prefetchData && prefetchData.profit.toString()) || "",
    max_stop_price: "",
    size: (prefetchData && prefetchData.size) || "",
    max_loss: "",
    technical_stop: "",
    exit_traget: "",
    time_stop: null,
    risk_or_reward: "",
    system_rules: 1,
    result_in_fear: 1,
    greed_or_pride: 1,
  });

  const handleProfit = (e) => {
    e.preventDefault();
    setData({ ...Data, profit: e.target.value });
  };

  const handleEntry = (e) => {
    e.preventDefault();
    setData({ ...Data, entry: e.target.value });
  };

  const handleReward = (e) => {
    e.preventDefault();
    setData({ ...Data, risk_or_reward: e.target.value });
  };
  const handleTimestop = (e) => {
    e.preventDefault();
    setData({ ...Data, time_stop: e.target.value });
  };
  const handleExitTarget = (e) => {
    e.preventDefault();
    setData({ ...Data, exit_traget: e.target.value });
  };
  const handleTechnicalStop = (e) => {
    e.preventDefault();
    setData({ ...Data, technical_stop: e.target.value });
  };
  const handleMaxLoss = (e) => {
    e.preventDefault();
    setData({ ...Data, max_loss: e.target.value });
  };
  const handleSize = (e) => {
    e.preventDefault();
    setData({ ...Data, size: e.target.value });
  };
  const handleMaxStop = (e) => {
    e.preventDefault();
    setData({ ...Data, max_stop_price: e.target.value });
  };
  const handleEntryOrder = (e) => {
    e.preventDefault();
    setData({ ...Data, order_price: e.target.value });
  };
  const handleHeadsUp = (e) => {
    e.preventDefault();
    setData({ ...Data, heads_up: e.target.value });
  };
  const handleDate = (e) => {
    e.preventDefault();
    setData({ ...Data, date: e.target.value });
  };
  const handleSymbol = (e) => {
    e.preventDefault();
    setData({ ...Data, symbol: e.target.value });
  };
  const handleType = (e) => {
    e.preventDefault();
    setData({ ...Data, trade_type: e.target.value });
  };
  const handleTrigger = (e) => {
    e.preventDefault();
    setData({ ...Data, trigger: e.target.value });
  };
  const handleSupporting = (e) => {
    e.preventDefault();
    setData({ ...Data, supporting_evidence: e.target.value });
  };
  const handleOpposing = (e) => {
    e.preventDefault();
    setData({ ...Data, opposing_evidence: e.target.value });
  };

  const handleChange = (e) => {
    let radioopt = e.currentTarget.getAttribute("value");
    setData({ ...Data, alerts_placed: radioopt });
  };
  const handleChangeAlert = (e) => {
    let radioopt = e.currentTarget.getAttribute("value");
    setData({ ...Data, counter_trend: radioopt });
  };

  const handleCreateForm = (e) => {
    e.preventDefault();
    props.handleFormSubmit(Data);
  };

  return (
    <div className="CreateTrader Container-p-20">
      <div className="d-flex justify-content-between">
        <Title six>Create Trade Journal</Title>
        <div
        className="CreateTrader-crossIcon"
          onClick={props.handleCross}
          style={{ color: "white", fontWeight: "bold", cursor: "pointer" }}
        >
          X
        </div>
      </div>
      <form onSubmit={handleCreateForm}>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          className="Section mtt-20"
          spacing={2}
        >
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Date</Title>
            <input
              onChange={handleDate}
              defaultValue={Data.date}
              className="inputField"
              type="date"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Symbol</Title>
            <input
              onChange={handleSymbol}
              defaultValue={Data.symbol}
              className="inputField"
              type="text"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Trade Type</Title>
            <Select
              labelId="demo-simple-select-label"
              className="input inputselect react-select-container"
              classNamePrefix="react-select"
              id="demo-simple-select"
              value={Data.trade_type}
              label="Age"
              onChange={handleType}
            >
              <MenuItem value="Sell">Sell</MenuItem>
              <MenuItem value="Buy">Buy</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <div className="mbb-20 d-flex">
          <Title seven>Is this a counter trend trade?</Title>
          <div className="mll-20 gapp-10 d-flex">
            <div
              onClick={handleChangeAlert}
              className="d-flex gapp-10"
              value="Yes"
            >
              <svg
                className={
                  "TraderRadio " +
                  (Data.counter_trend === "Yes" && "RadioSelected")
                }
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  fill="white"
                  stroke="#8B8E93"
                  strokeWidth="6"
                />
              </svg>
              <Title four>Yes</Title>
            </div>
            <div
              onClick={handleChangeAlert}
              className="d-flex gapp-10"
              value="No"
            >
              <svg
                className={
                  "TraderRadio " +
                  (Data.counter_trend === "No" && "RadioSelected")
                }
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  fill="white"
                  stroke="#8B8E93"
                  strokeWidth="6"
                />
              </svg>
              <Title four>No</Title>
            </div>
          </div>
        </div>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          className="Section"
        >
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Trigger</Title>
            <textarea
              onChange={handleTrigger}
              defaultValue={Data.trigger}
              className="inputField textarea"
              type="text"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Supporting Evidence</Title>
            <textarea
              onChange={handleSupporting}
              defaultValue={Data.supporting_evidence}
              className="inputField textarea"
              type="text"
            />
          </Grid>
          <Grid item xl={4} lg={4} xs={12} sm={12} className="Selectinput">
            <Title three>Opposing Evidence</Title>
            <textarea
              onChange={handleOpposing}
              defaultValue={Data.opposing_evidence}
              className="inputField textarea"
              type="text"
            />
          </Grid>
        </Grid>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          item
          className="Section mtt-20"
        >
          <Grid
            item
            lg={12}
            sm={12}
            xs={12}
            className="Selectinput"
            paddingRight={"16px"}
          >
            <Title three>Heads up</Title>
            <textarea
              onChange={handleHeadsUp}
              defaultValue={Data.heads_up}
              className="inputField textarea"
              type="text"
            />
          </Grid>
          <Grid
            item
            lg={6}
            sm={12}
            xs={12}
            className="Selectinput"
            paddingRight={"16px"}
          >
            <Title three>Profit</Title>
            <input
              onChange={handleProfit}
              defaultValue={Data.profit}
              className="inputField"
              type="text"
            />
          </Grid>
          <Grid
            lg={6}
            sm={12}
            xs={12}
            className="Selectinput"
            paddingTop={"16px"}
            paddingRight={"16px"}
          >
            <Title three>Entry</Title>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={Data.entry}
              label="entry"
              className="input inputselect"
              onChange={handleEntry}
            >
              <MenuItem value="In">In</MenuItem>
              <MenuItem value="Out">Out</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid
          container
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          spacing={2}
          className="Section"
        >
          <Grid item container className="" lg={12} spacing={2}>
            <Grid item lg={6} sm={12} xs={12} spacing={1}>
              <Title seven>Entry Plan</Title>
              <Grid item className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Entry order price</Title>
                <input
                  onChange={handleEntryOrder}
                  defaultValue={Data.order_price}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Max stop price</Title>
                <input
                  onChange={handleMaxStop}
                  defaultValue={Data.max_stop_price}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Size</Title>
                <input
                  onChange={handleSize}
                  defaultValue={Data.size}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2}>
                <Title three>Max $ loss</Title>
                <input
                  onChange={handleMaxLoss}
                  defaultValue={Data.max_loss}
                  className="inputField"
                  type="text"
                />
              </Grid>
            </Grid>
            <Grid item lg={6} sm={12} xs={12} spacing={1}>
              <Title seven>Exit Plan</Title>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Technical Stop</Title>
                <input
                  onChange={handleTechnicalStop}
                  defaultValue={Data.technical_stop}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Exit target/Trigger</Title>
                <input
                  onChange={handleExitTarget}
                  defaultValue={Data.exit_traget}
                  className="inputField"
                  type="text"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2} marginBottom={2}>
                <Title three>Time stop</Title>
                <input
                  onChange={handleTimestop}
                  defaultValue={Data.time_stop}
                  className="inputField"
                  type="time"
                />
              </Grid>
              <Grid className="Selectinput" marginTop={2}>
                <Title three>Est. Risk/Reward</Title>
                <input
                  onChange={handleReward}
                  defaultValue={Data.risk_or_reward}
                  className="inputField"
                  type="text"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item lg={12} className="Section">
          <Grid
            container
            item
            lg={12}
            className="Selectinput SectionNotes"
            paddingRight={"16px"}
          >
            <Title three>Notes/Insights/Results</Title>
            {
              <CKEditor
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setData({ ...Data, notes: data });
                  // this.setState({ content: editor.getData() });
                }}
              />
            }
            {/*<textarea
              onChange={handleNotes}
              defaultValue={Data.notes}
              className="inputField"
              type="text"
              rows="10"
            />*/}
          </Grid>
        </Grid>
        <div>
          <div className="mbb-20 d-flex">
            <Title seven>Orders/Alerts Placed?</Title>
            <div className="mll-20 gapp-10 d-flex">
              <div
                onClick={handleChange}
                className="d-flex gapp-10"
                value="Yes"
              >
                <svg
                  className={
                    "TraderRadio " +
                    (Data.alerts_placed === "Yes" && "RadioSelected")
                  }
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill="white"
                    stroke="#8B8E93"
                    strokeWidth="6"
                  />
                </svg>
                <Title four>Yes</Title>
              </div>
              <div onClick={handleChange} className="d-flex gapp-10" value="No">
                <svg
                  className={
                    "TraderRadio " +
                    (Data.alerts_placed === "No" && "RadioSelected")
                  }
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill="white"
                    stroke="#8B8E93"
                    strokeWidth="6"
                  />
                </svg>
                <Title four>No</Title>
              </div>
            </div>
          </div>
        </div>
        <Grid
          lg={8}
          className="Section align-items-center"
          sx={{ gap: "2rem", flexWrap: "wrap" }}
        >
          <div style={{ width: "100%" }}>
            <Title six>Rate yourself</Title>
          </div>
          <div>
            <Title seven>Follows system rules ?</Title>
            <Rating
              name="simple-controlled"
              icon={<Fill />}
              emptyIcon={<Empty />}
              value={Data.system_rules}
              onChange={(event, newValue) => {
                setData({ ...Data, system_rules: newValue });
              }}
            />
          </div>
          <div>
            <Title seven>Result in fear/anxiety ?</Title>
            <Rating
              name="simple-controlled"
              value={Data.result_in_fear}
              icon={<Fill />}
              emptyIcon={<Empty />}
              onChange={(event, newValue) => {
                setData({ ...Data, result_in_fear: newValue });
              }}
            />
          </div>
          <div>
            <Title seven>Spark ‘greed’ or ‘pride’ ?</Title>
            <Rating
              icon={<Fill />}
              emptyIcon={<Empty />}
              name="simple-controlled"
              value={Data.greed_or_pride}
              onChange={(event, newValue) => {
                setData({ ...Data, greed_or_pride: newValue });
              }}
            />
          </div>
        </Grid>
        <div className="text-align-center">
          <button className="Button" style={{ width: "70%" }}>
            Create Trade Journal
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTrader;
